import consumer from "./consumer";

export function subscribeToSessions(tenantId, onEvent) {
    return consumer.subscriptions.create(
        { channel: "SessionsChannel", tenant_id: tenantId },
        {
            connected() {
                console.log(`+++Connected to sessions for tenant ${tenantId}`);
            },
            disconnected() {
                console.log(`---Disconnected from sessions for tenant ${tenantId}`);
            },
            received(data) {
                onEvent(data);
            }
        }
    );
}